// Categoria com busca (dono, 26/10/2026): digita para achar ou rola a lista.
import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { TODOS } from "./regras";

const sem = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export default function CategoriaBusca({ categorias, valor, aoMudar, contagem }) {
  const [aberto, setAberto] = useState(false);
  const escolher = (v) => { aoMudar(v); setAberto(false); };
  const ativa = valor && valor !== TODOS;
  return (
    <Popover open={aberto} onOpenChange={setAberto}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={aberto} data-e2e="filtro-categoria"
          className={`h-8 w-full rounded-md border bg-background px-2.5 flex items-center justify-between gap-2 text-left text-xs hover:border-primary/50 focus:outline-none focus:ring-2 focus:ring-ring/40 ${ativa ? "border-primary text-foreground font-semibold" : "text-muted-foreground"}`}>
          <span className="truncate">{ativa ? valor : "Todas as categorias"}</span>
          <ChevronsUpDown className="w-3.5 h-3.5 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] min-w-[240px] p-0" align="start">
        <Command filter={(v, busca) => (sem(v).includes(sem(busca)) ? 1 : 0)}>
          <CommandInput placeholder="Buscar categoria…" data-e2e="filtro-categoria-busca" />
          <CommandList className="max-h-72">
            <CommandEmpty>Nenhuma categoria encontrada.</CommandEmpty>
            <CommandGroup>
              <CommandItem value="Todas as categorias" onSelect={() => escolher(TODOS)}>
                <Check className={`w-3.5 h-3.5 mr-2 ${ativa ? "opacity-0" : "opacity-100"}`} />
                Todas as categorias
              </CommandItem>
              {categorias.map((c) => (
                <CommandItem key={c.id} value={`${c.name} ${c.id}`} onSelect={() => escolher(c.name)}>
                  <Check className={`w-3.5 h-3.5 mr-2 shrink-0 ${valor === c.name ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{c.name}</span>
                  <span className="ml-2 text-[10px] text-muted-foreground tabular-nums">{contagem(c.name)}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
